// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recalled-items-modal .MuiBackdrop-root {
  background-color: rgba(15, 23, 42, 0.3) !important;
  backdrop-filter: blur(4px);
}

.recalled-items-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 80vw;
  max-width: 1040px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border-left: 1px solid rgba(226, 232, 240, 0.8);
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
  box-shadow: 0 28px 90px rgba(15, 23, 42, 0.22);
  display: flex;
  flex-direction: column;
  outline: none;
  animation: slideInRight 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.recalled-items-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
  padding: 20px 24px;
}

.recalled-items-header h2 {
  font-size: calc(28px + var(--kds-font-delta, 0px));
  font-weight: 500;
  letter-spacing: -0.02em;
  color: #0f172a;
  margin: 0;
}

.recalled-items-close-btn {
  display: inline-flex;
  height: 36px;
  width: 36px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: white;
  color: #64748b;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.2s;
  cursor: pointer;
}

.recalled-items-close-btn:hover {
  border-color: #cbd5e1;
  background-color: #f8fafc;
  color: #0f172a;
}

.recalled-items-content {
  flex: 1;
  padding: 10px 24px;
  overflow-y: auto;
  min-height: 0;
}

/* Custom Scrollbar for Modal Content */
.recalled-items-content::-webkit-scrollbar {
  width: 8px;
}

.recalled-items-content::-webkit-scrollbar-track {
  background: transparent;
}

.recalled-items-content::-webkit-scrollbar-thumb {
  background-color: #94a3b8;
  border-radius: 10px;
  border: 2px solid transparent;
  background-clip: padding-box;
}

.recalled-items-content::-webkit-scrollbar-thumb:hover {
  background-color: #64748b;
}

.recalled-items-table-wrapper {
  overflow: hidden; /* Changed back to hidden to clip scrolling rows */
  border-radius: 24px;
  background-color: white;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
  margin: 10px 4px 24px 4px;
  border: 1px solid rgba(226, 232, 240, 0.5);
  position: relative; /* Create positioning context for sticky th */
}

.recalled-items-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
}

.recalled-items-table th {
  background-color: #f8fafc; /* Opaque background for sticky header */
  padding: 16px 20px;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #64748b;
  text-align: left;
  border: none;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 10;
}

/* Ensure header corners follow the wrapper's radius */
.recalled-items-table th:first-child {
  border-top-left-radius: 24px;
}
.recalled-items-table th:last-child {
  border-top-right-radius: 24px;
}

.recalled-items-table td {
  padding: 20px;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  color: #334155;
  border: none;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

.recalled-items-table tr:last-child td {
  border-bottom: none;
}

/* Ensure bottom corners follow the wrapper's radius */
.recalled-items-table tr:last-child td:first-child {
  border-bottom-left-radius: 24px;
}
.recalled-items-table tr:last-child td:last-child {
  border-bottom-right-radius: 24px;
}

.recalled-items-table tr {
  transition: background-color 0.2s;
}

.recalled-items-table tr:hover td {
  background-color: rgba(248, 250, 252, 0.8);
}

/* Updated column widths to ensure headers fit on one line */
.col-sno {
  width: 60px;
}
.col-name {
  width: 22%;
}
.col-qty {
  width: 70px;
}
.col-reason {
  width: 20%;
}
.col-table {
  width: 80px;
}
.col-wastage {
  width: 160px;
}
.col-revenue {
  width: 160px;
}

.recalled-items-sno {
  font-weight: 500;
  color: #64748b;
}

.recalled-items-name {
  font-weight: 600;
  color: #0f172a;
}

.recalled-items-qty {
  font-weight: 500;
  color: #334155;
}

.recalled-items-reason {
  line-height: 1.5;
  color: #475569;
  word-break: break-word;
}

.recalled-items-table-num {
  font-weight: 500;
  color: #334155;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.font-semibold {
  font-weight: 600;
}

.text-slate-800 {
  color: #1e293b;
}

/* Pagination Styling */
.recalled-items-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-top: 1px solid rgba(226, 232, 240, 0.8);
  background-color: white;
  border-bottom-left-radius: 24px;
}

.pagination-info {
  font-size: calc(14px + var(--kds-font-delta, 0px));
  color: #64748b;
}

.pagination-controls-kds-recalled {
  display: flex;
  gap: 8px;
}

.pagination-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background-color: white;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  font-weight: 500;
  color: #334155;
  cursor: pointer;
  transition: all 0.2s;
}

.pagination-btn:hover:not(:disabled) {
  border-color: #cbd5e1;
  background-color: #f8fafc;
  color: #0f172a;
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Search Bar Styles */
.recalled-search-container {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f1f5f9;
  background-color: rgba(248, 250, 252, 0.7);
  padding: 16px 24px;
  margin: 0;
  box-sizing: border-box;
}

.recalled-input-container {
  display: flex;
  height: 44px;
  width: 100%;
  align-items: center;
  gap: 8px;
  border-radius: 50px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 0 12px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  position: relative;
}

.recalled-search-bar {
  width: 100%;
  border: 0 !important;
  background: transparent !important;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  color: #334155;
  outline: none;
  padding: 0 !important;
  height: 100%;
  font-weight: 400;
}

.recalled-search-bar::placeholder {
  color: #94a3b8;
}

.recalled-input-container > *:first-child {
  position: static !important;
  transform: none !important;
  display: flex;
  align-items: center;
  color: #94a3b8 !important;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/KDS/components/RecalledItemsModal/RecalledItemsModal.css"],"names":[],"mappings":"AAAA;EACE,kDAAkD;EAClD,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,6DAA6D;EAC7D,+CAA+C;EAC/C,4BAA4B;EAC5B,+BAA+B;EAC/B,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,0CAA0C;EAC1C,uBAAuB;EACvB,cAAc;EACd,2CAA2C;EAC3C,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA,uCAAuC;AACvC;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB,EAAE,kDAAkD;EACpE,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,yBAAyB;EACzB,0CAA0C;EAC1C,kBAAkB,EAAE,6CAA6C;AACnE;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,wCAAwC;EACnE,kBAAkB;EAClB,kDAAkD;EAClD,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA,sDAAsD;AACtD;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,cAAc;EACd,YAAY;EACZ,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,4DAA4D;AAC5D;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,0CAA0C;EAC1C,kBAAkB;EAClB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,2CAA2C;EAC3C,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kCAAkC;EAClC,kDAAkD;EAClD,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB","sourcesContent":[".recalled-items-modal .MuiBackdrop-root {\n  background-color: rgba(15, 23, 42, 0.3) !important;\n  backdrop-filter: blur(4px);\n}\n\n.recalled-items-container {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 80vw;\n  max-width: 1040px;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n  border-left: 1px solid rgba(226, 232, 240, 0.8);\n  border-top-left-radius: 24px;\n  border-bottom-left-radius: 24px;\n  box-shadow: 0 28px 90px rgba(15, 23, 42, 0.22);\n  display: flex;\n  flex-direction: column;\n  outline: none;\n  animation: slideInRight 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n.recalled-items-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.8);\n  padding: 20px 24px;\n}\n\n.recalled-items-header h2 {\n  font-size: calc(28px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n  margin: 0;\n}\n\n.recalled-items-close-btn {\n  display: inline-flex;\n  height: 36px;\n  width: 36px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: white;\n  color: #64748b;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  transition: all 0.2s;\n  cursor: pointer;\n}\n\n.recalled-items-close-btn:hover {\n  border-color: #cbd5e1;\n  background-color: #f8fafc;\n  color: #0f172a;\n}\n\n.recalled-items-content {\n  flex: 1;\n  padding: 10px 24px;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n/* Custom Scrollbar for Modal Content */\n.recalled-items-content::-webkit-scrollbar {\n  width: 8px;\n}\n\n.recalled-items-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.recalled-items-content::-webkit-scrollbar-thumb {\n  background-color: #94a3b8;\n  border-radius: 10px;\n  border: 2px solid transparent;\n  background-clip: padding-box;\n}\n\n.recalled-items-content::-webkit-scrollbar-thumb:hover {\n  background-color: #64748b;\n}\n\n.recalled-items-table-wrapper {\n  overflow: hidden; /* Changed back to hidden to clip scrolling rows */\n  border-radius: 24px;\n  background-color: white;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);\n  margin: 10px 4px 24px 4px;\n  border: 1px solid rgba(226, 232, 240, 0.5);\n  position: relative; /* Create positioning context for sticky th */\n}\n\n.recalled-items-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  table-layout: fixed;\n}\n\n.recalled-items-table th {\n  background-color: #f8fafc; /* Opaque background for sticky header */\n  padding: 16px 20px;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: #64748b;\n  text-align: left;\n  border: none;\n  border-bottom: 1px solid #e2e8f0;\n  white-space: nowrap;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n/* Ensure header corners follow the wrapper's radius */\n.recalled-items-table th:first-child {\n  border-top-left-radius: 24px;\n}\n.recalled-items-table th:last-child {\n  border-top-right-radius: 24px;\n}\n\n.recalled-items-table td {\n  padding: 20px;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  color: #334155;\n  border: none;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: middle;\n}\n\n.recalled-items-table tr:last-child td {\n  border-bottom: none;\n}\n\n/* Ensure bottom corners follow the wrapper's radius */\n.recalled-items-table tr:last-child td:first-child {\n  border-bottom-left-radius: 24px;\n}\n.recalled-items-table tr:last-child td:last-child {\n  border-bottom-right-radius: 24px;\n}\n\n.recalled-items-table tr {\n  transition: background-color 0.2s;\n}\n\n.recalled-items-table tr:hover td {\n  background-color: rgba(248, 250, 252, 0.8);\n}\n\n/* Updated column widths to ensure headers fit on one line */\n.col-sno {\n  width: 60px;\n}\n.col-name {\n  width: 22%;\n}\n.col-qty {\n  width: 70px;\n}\n.col-reason {\n  width: 20%;\n}\n.col-table {\n  width: 80px;\n}\n.col-wastage {\n  width: 160px;\n}\n.col-revenue {\n  width: 160px;\n}\n\n.recalled-items-sno {\n  font-weight: 500;\n  color: #64748b;\n}\n\n.recalled-items-name {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.recalled-items-qty {\n  font-weight: 500;\n  color: #334155;\n}\n\n.recalled-items-reason {\n  line-height: 1.5;\n  color: #475569;\n  word-break: break-word;\n}\n\n.recalled-items-table-num {\n  font-weight: 500;\n  color: #334155;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.text-slate-800 {\n  color: #1e293b;\n}\n\n/* Pagination Styling */\n.recalled-items-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  border-top: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: white;\n  border-bottom-left-radius: 24px;\n}\n\n.pagination-info {\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  color: #64748b;\n}\n\n.pagination-controls-kds-recalled {\n  display: flex;\n  gap: 8px;\n}\n\n.pagination-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background-color: white;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  color: #334155;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.pagination-btn:hover:not(:disabled) {\n  border-color: #cbd5e1;\n  background-color: #f8fafc;\n  color: #0f172a;\n}\n\n.pagination-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Search Bar Styles */\n.recalled-search-container {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #f1f5f9;\n  background-color: rgba(248, 250, 252, 0.7);\n  padding: 16px 24px;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.recalled-input-container {\n  display: flex;\n  height: 44px;\n  width: 100%;\n  align-items: center;\n  gap: 8px;\n  border-radius: 50px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 0 12px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  box-sizing: border-box;\n  position: relative;\n}\n\n.recalled-search-bar {\n  width: 100%;\n  border: 0 !important;\n  background: transparent !important;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  color: #334155;\n  outline: none;\n  padding: 0 !important;\n  height: 100%;\n  font-weight: 400;\n}\n\n.recalled-search-bar::placeholder {\n  color: #94a3b8;\n}\n\n.recalled-input-container > *:first-child {\n  position: static !important;\n  transform: none !important;\n  display: flex;\n  align-items: center;\n  color: #94a3b8 !important;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
